import { motion } from "framer-motion";
import { FiBatteryCharging, FiWifi } from "react-icons/fi";
import phoneImage from '../assets/img/phone-img.png';

const Example = () => {
  return (
    <section className="grid place-content-center p-12">
      <FloatingPhone />
    </section>
  );
};

const FloatingPhone = () => {
  return (
    <div
      style={{
        transformStyle: "preserve-3d",
        transform: "rotateY(-30deg) rotateX(15deg)",
      }}
      className="rounded-[32px] bg-gradient-to-br from-violet-600 via-purple-600 to-violet-700 p-1 shadow-2xl"
    >
      <motion.div
        initial={{
          transform: "translateZ(8px) translateY(-2px)",
        }}
        animate={{
          transform: "translateZ(32px) translateY(-8px)",
        }}
        transition={{
          repeat: Infinity,
          repeatType: "mirror",
          duration: 2,
          ease: "easeInOut",
        }}
        className="relative h-[30rem] w-[18rem] rounded-[28px] border-[3px] border-zinc-800/50 bg-gradient-to-b from-zinc-900 via-zinc-950 to-black p-1.5 shadow-[0_0_30px_rgba(124,58,237,0.3)]"
      >
        <HeaderBar />
        <Screen />
      </motion.div>
    </div>
  );
};

const HeaderBar = () => {
  return (
    <>
      {/* Dynamic Island */}
      <div className="absolute left-[50%] top-2.5 z-10 h-2.5 w-20 -translate-x-[50%] rounded-full bg-black shadow-lg"></div>
      <div className="absolute right-4 top-2 z-10 flex gap-2 text-xs">
        <FiWifi className="text-white/70" />
        <FiBatteryCharging className="text-white/70" />
      </div>
    </>
  );
};

const Screen = () => {
  return (
    <div className="relative z-0 grid h-full w-full place-content-center overflow-hidden rounded-[20px] bg-gradient-to-br from-violet-50 to-purple-50">
      {/* Background Image with Gradient Overlay */}
      <div className="absolute inset-0 overflow-hidden rounded-[20px]">
        <img
          src={phoneImage}
          alt=""
          className="absolute inset-0 h-full w-full object-cover" style={{ objectPosition: '25% center' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-violet-500/5 to-violet-600/20" />
      </div>

      {/* Modern Button */}
      <a href="/about" className="absolute bottom-6 left-6 right-6 z-10 group">
        <button className="w-full rounded-xl border border-violet-200 bg-white/95 backdrop-blur-md py-3 px-6 text-sm font-semibold text-violet-600 shadow-sm transition-all duration-300 hover:bg-violet-50 hover:border-violet-300 hover:shadow-md">
          About me
        </button>
      </a>

      {/* Enhanced Decorative Gradient Circle */}
      <div className="absolute -bottom-72 left-[50%] h-96 w-96 -translate-x-[50%] rounded-full bg-gradient-to-t from-violet-600 via-purple-500 to-transparent opacity-80" />
      <div className="absolute -bottom-64 left-[50%] h-80 w-80 -translate-x-[50%] rounded-full bg-gradient-to-t from-purple-600 to-transparent opacity-60 blur-2xl" />
    </div>
  );
};

export default Example;